import React from 'react'
import AdmissionCommitteeDataListData from '../../features/AdmissionCommitteeManagement/AdmissionCommitteeDataList'

const AdmissionCommitteeList = () => {
    return (
        <div>
            <AdmissionCommitteeDataListData />
        </div>
    )
}

export default AdmissionCommitteeList
